<div class="custom-header">
    <button
        type="button"
        (click)="previousClicked()"
        [disabled]="!previousEnabled()">
        <div
            class="pi pi-chevron-left" 
            style="font-size: 1rem; color: var(--text-neutral)"
            >
        </div>
    </button>
    <span>
        {{ calendarHeader.periodButtonText}}
    </span>
    <button 
        type="button"
        (click)="nextClicked()"
        [disabled]="!nextEnabled()"
        >
        <div
            class="pi pi-chevron-right" 
            style="font-size: 1rem; color: var(--text-neutral)"
            >
        </div>
    </button>
</div>
